module.exports = __webpack_public_path__ + "static/media/shot.35178d90.svg";